import { lazy } from 'react';
import { formatMessage } from '../utils/text';

const ProjectItemList = lazy(() => import('../pages/ProjectItemList'));

export const ROUTES = [
  { path: '/:linkId', component: ProjectItemList, title: formatMessage('page.title.projectItemList') },
  { path: '/:linkId/:parentId', component: ProjectItemList, title: formatMessage('page.title.projectItemList') },
];
